import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initMetaPixel, meta } from "../lib/metaPixel";

export const MetaPixelRoutes = () => {
  const location = useLocation();
  const lastRoute = useRef(null);

  useEffect(() => {
    initMetaPixel();
    const routeKey = `${location.pathname}${location.search}${location.hash}`;
    if (lastRoute.current === routeKey) return;
    lastRoute.current = routeKey;
    meta.pageView();
  }, [location.pathname, location.search, location.hash]);

  return null;
};
